module.exports = __webpack_public_path__ + "static/media/bg.5d2babc9.svg";